module.exports = __webpack_public_path__ + "static/media/vf-button-top-black.941088af.svg";